import { render, staticRenderFns } from "./Sweetdialog.vue?vue&type=template&id=ec26dc1c&"
import script from "./Sweetdialog.vue?vue&type=script&lang=js&"
export * from "./Sweetdialog.vue?vue&type=script&lang=js&"
import style0 from "./Sweetdialog.vue?vue&type=style&index=0&id=ec26dc1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports